import React from "react";

const Hero = ({ home }) => {
  return (
    <div
      id="rs-slider"
      className="relative min-h-[90vh] flex items-center justify-center pt-32 lg:pt-40 pb-16 overflow-hidden"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.vecteezy.com/system/resources/previews/008/680/961/non_2x/abstract-technology-background-free-vector.jpg"
          alt="Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#000929]/80"></div>
      </div>

      {/* Content Container */}
      <div className="container mx-auto px-4 relative z-10 text-center">
        <div className="max-w-4xl mx-auto space-y-8 animate-fadeInUp">
          {/* Acronym */}
          <h1 className="text-3xl md:text-5xl lg:text-5xl font-extrabold text-white tracking-tighter drop-shadow-2xl">
            {home.acroynm[0].text}
          </h1>

          {/* Title */}
          <div className="space-y-4">
            <h2 className="text-2xl md:text-3xl lg:text-3xl font-bold text-white leading-tight drop-shadow-md">
              {home.title[0].text}
            </h2>
            <p className="text-xl md:text-2xl text-[#d90845] font-bold tracking-[0.2em] uppercase">
              (Hybrid Mode)
            </p>
          </div>

          {/* Organized By */}
          <div className="bg-white/10 backdrop-blur-lg border border-white/20 p-4 md:p-6 rounded-2xl inline-block shadow-2xl">
            <h4 className="text-lg md:text-xl text-white/90 font-medium">
              Organized By:{" "}
              <span className="text-white font-extrabold">
                {home.oragnized[0].text}
              </span>
            </h4>
          </div>

          {/* Date and CTA */}
          <div className="flex flex-col items-center space-y-8 pt-2">
            <div className="flex items-center space-x-3 text-white text-lg md:text-2xl font-semibold">
              <i className="fa fa-calendar text-[#d90845]"></i>
              <span>{home.conference_date[0].text}</span>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 w-full max-w-xl mx-auto">
              <a
                href={home.paper_submission_link[0].text}
                className="w-full sm:w-auto px-8 py-3 bg-white text-[#d90845] font-black text-lg rounded-full hover:bg-[#d90845] hover:text-white transition-all shadow-lg hover:shadow-xl active:scale-95 text-center"
              >
                Submit Paper
              </a>
              <a
                href={home.registration_link[0].text}
                className="w-full sm:w-auto px-8 py-3 bg-[#d90845] text-white font-black text-lg rounded-full hover:bg-[#c7073f] transition-all shadow-lg hover:shadow-xl active:scale-95 border-2 border-transparent hover:border-white/30 text-center"
              >
                Registration
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Slide Shape and Professional Transition */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-[#000929] to-transparent z-10 opacity-60"></div>
      <div className="absolute bottom-0 left-0 w-full h-16 bg-gradient-to-t from-white to-transparent z-20"></div>
    </div>
  );
};

export default Hero;
